var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-area"},[_c('h3',{staticClass:"promo-section-header forza-bold"},[_vm._v("trusted brands")]),_c('div',{staticClass:"promo-area-content"},[_c(_vm.componentName,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }